import { _matchStatusTypes, sportsDataSearchTypes } from 'projectSpecific/sports/helpers/sportsEnums';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { mediaHelpers } from '../../importing/mediaResults';
import { ammendRankingsFromGs } from './reducerHelpers/seasonSportsRankingsData';
import { seasonalUpdateTypes } from './reducerHelpers/seasonalDataHelpers';
import { seasonalHelpers } from './reducerHelpers/seasonalHelpers';

const rts = {
  handleAmmend_gsMatches: 'handleAmmend_gsMatches',
  handleGet_gsMatchesTest: 'handleGet_gsMatchesTest',
  handleGet_gsRankings: 'handleGet_gsRankings',
  handleGet_gsRosters: 'handleGet_gsRosters',
  handleGet_mediaMatches: 'handleGet_mediaMatches',
  handleSet_currentFlatFiltered: 'handleSet_currentFlatFiltered',
  handleSet_gsRankings: 'handleSet_gsRankings',
  handleSet_gsRosters: 'handleSet_gsRosters',
  handleSet_matchDataUpdates: 'handleSet_matchDataUpdates',
  handleSet_matchPlayoffPendings: 'handleSet_matchPlayoffPendings',
  handleSet_schoolResults: 'handleSet_schoolResults',
  handleShow_matchEdit: 'handleShow_matchEdit',
  handleUpdate_gsMatchesSport: 'handleUpdate_gsMatchesSport',
  handleUpdate_gsRankings: 'handleUpdate_gsRankings',
  ...grts,
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sports season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const sportsDataReducer = (state, action) => {

  const {
    _matchStatusGroups,
    _sportsYearAbr,
    database_fns,
    fn_cls,
    gameScoringType,
    latestSeason,
    links_score,
    mainDb,
    matches_flat,
    matches_info,
    matchResultsInfo,
    pathViews,
    sportPermissions,
    sportsKey,
    teams,
    useScoringCollection,
    useScoringCollectionOnly,
  } = state

  const { matchUpdates_dot } = matchResultsInfo ?? {}

  const { values } = matches_flat ?? {}
  const { season: matches_flat_season, playoffs: matches_flat_playoff } = values ?? {}

  const { type, dispatch } = action

  const sportsData_handlers = sportsDataHandlers(dispatch)
  const { handleFunctionResponse, handleSet_gsRankings, handleSet_gsRosters } = sportsData_handlers

  switch (type) {

    case rts.handleAmmend_gsMatches:
      return {
        ...state,
        updating: false,
        gsMatchedRefreshed: true,
        forPlayoffs: action.forPlayoffs,
        matchResultsInfo: action.matchResultsInfo,
      }

    case rts.handleGet_gsRankings:
      fn_cls.getGoogleSheetRange(action.gsValues ? action.gsValues : links_score, handleSet_gsRankings, null, null, null, state.latestSeason)
      return { ...state }

    case rts.handleGet_gsRosters:
      fn_cls.getGoogleSheetRange(action.gsValues ? action.gsValues : links_score, handleSet_gsRosters)
      return { ...state }

    case rts.handleSet_gsRosters:
      const { rosters_gs } = action
      return { ...state, updating: false, rosters_info: {} }

    case rts.handleSet_gsRankings:
      const { rankings_gs } = action
      const _rankings = ammendRankingsFromGs(rankings_gs)
      return { ...state, updating: false, rankings_info: { rankings: _rankings } }

    case rts.handleGet_mediaMatches:
      mediaHelpers.getMedia_results(action.dateGroupKeys, action.forPlayoffs, state.links_score, action.year, action._sportsAbr, teams, action.forRefresh, handleSet_mediaResults)
      return { ...state, sportsDataSearchType: action.forPlayoffs ? sportsDataSearchTypes.media_playoffResults : sportsDataSearchTypes.media_results }

    case rts.handleSet_schoolResults:
      return { ...state, schoolData: action.schoolData }

    case rts.handleGet_gsMatchesTest:
      // getGsTest('17wW4AqQOkVkHTAQ9ttl__AIQQhHadfVf4OppcAZSkLg', 'Results 2024')
      return { ...state }

    case rts.handleSet_matchDataUpdates:
      return { ...state, matchUpdates_dot: action.matchDataUpdates }

    case rts.handleSet_matchPlayoffPendings:
      return { ...state, matchPlayoffPendings: action.matchPlayoffPendings }

    case rts.handleSet_currentFlatFiltered:
      const _matches_flat = { ...matches_flat }
      const { ft } = action
      let _updateCaption = 'Update Match Results'
      let updateAllowed;
      switch (ft) {
        case _matchStatusTypes.allUpdates:
        case _matchStatusTypes.cancelled:
        case _matchStatusTypes.dateChanged:
        case _matchStatusTypes.existingDb:
        case _matchStatusTypes.inversed:
        case _matchStatusTypes.matchNew:
        case _matchStatusTypes.nonDistrict:
        case _matchStatusTypes.postponed:
        case _matchStatusTypes.resultsChanged:
        case _matchStatusTypes.resultsNew:
        case _matchStatusTypes.season:
        case _matchStatusTypes.seasonPlayoff:
          updateAllowed = true
          break;
        default:
          // (1652
          updateAllowed = ft ? false : true
      }
      if (ft) {

        let _matchUpdates_data_selected;
        if (matchUpdates_dot && ft && matchUpdates_dot[ft]) {
          _matchUpdates_data_selected = matchUpdates_dot[ft]
          matchResultsInfo._matchUpdates_data_selected = _matchUpdates_data_selected
        }
        const x = _matchStatusGroups ? _matchStatusGroups[ft] : []
        _matches_flat.counts.filtered = x ? Object.keys(x).length : 0
        _matches_flat.filtered.all = x
        return { ...state, matches_flat: _matches_flat, filterType: ft, updateCaption: _updateCaption, updateAllowed, matchResultsInfo }
      } else {
        if (state.forPlayoffs) {
          _matches_flat.counts.playoffs = matches_flat_playoff ? Object.keys(matches_flat_playoff).length : 0
          _matches_flat.filtered.playoffs = matches_flat_playoff
          return { ...state, matches_flat: _matches_flat, filterType: null, updateCaption: _updateCaption, updateAllowed }
        } else {
          _matches_flat.counts.season = matches_flat_season ? Object.keys(matches_flat_season).length : 0
          _matches_flat.filtered.season = matches_flat_season
          return { ...state, matches_flat: _matches_flat, filterType: null, updateCaption: _updateCaption, updateAllowed }
        }
      }

    case rts.handleUpdate_gsMatchesSport:

      const { forPlayoffs, forRefresh, repairResults } = action

      const _cb = (res) => {
        const response_data = { success: true }
        handleFunctionResponse(response_data, dispatch)
      }

      const _updateProps = {
        callback: _cb,
        forPlayoffs,
        forRefresh,
        matchDataUpdates: matchUpdates_dot,
        repairResults,
        pathViews,
        pks: seasonalHelpers.getPks(pathViews, latestSeason, sportsKey),
        seasonalUpdateType: seasonalUpdateTypes.matchesList,
        useScoringCollection,
        useScoringCollectionOnly,
        sportPermissions,
        database_fns
      }

      if (matchUpdates_dot) {
        seasonalHelpers.updateSeasonalMatches_allByLevel(_updateProps)
      }

      return { ...state }

    case rts.handleUpdate_gsRankings:
      const { rankings } = action.rankings_info ?? {}
      const _cbr = (res) => {
        const response_data = { success: true }
        handleFunctionResponse(response_data, dispatch)
      }
      if (rankings) {
        const data_rankings = {}
        Object.keys(rankings).forEach(selectedWeek => {
          const ranking = rankings[selectedWeek]
          Object.keys(ranking).forEach(selectedLevel => {
            data_rankings['rankings' + '.' + selectedWeek + '.' + selectedLevel] = ranking[selectedLevel];
          })
        })
        const _pkss = seasonalHelpers.getPks(pathViews, state.latestSeason, sportsKey, ['teams'])
        const _updateProps = seasonalHelpers.getUpdateProps(database_fns, sportPermissions, pathViews, _pkss, action.callback, 'rankings_seasonal', null, data_rankings, null, rankings, _sportsYearAbr)
        seasonalHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.rankings, _updateProps)
        _cbr()
      }
      return { ...state }

    case rts.handleShow_matchEdit:
      return { ...state, showMatchProp: !state.showMatchProp, matchProp: action.matchProp, matchData_match: action.match }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStopUpdate:
    case rts.handleStartUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation }, { gsMatchedRefreshed: false })

    default:
      return { ...state }
  }
}

export const sportsDataHandlers = (dispatch) => {
  return {
    handleAmmend_gsMatches: (matchResultsInfo, forPlayoffs) => { dispatch({ type: rts.handleAmmend_gsMatches, dispatch, matchResultsInfo, forPlayoffs }) },
    handleGet_gsMatchesTest: (gsValues) => { dispatch({ type: rts.handleGet_gsMatchesTest, dispatch, gsValues }) },
    handleGet_gsRankings: (gsValues) => { dispatch({ type: rts.handleGet_gsRankings, dispatch, gsValues }) },
    handleGet_gsRosters: (gsValues) => { dispatch({ type: rts.handleGet_gsRosters, dispatch, gsValues }) },
    handleGet_mediaMatches: (date, dateGroupKeys, forPlayoffs, year, forRefresh) => { dispatch({ type: rts.handleGet_mediaMatches, dispatch, date, dateGroupKeys, forPlayoffs, year, forRefresh }) },
    handleSet_currentFlatFiltered: (ft) => { dispatch({ type: rts.handleSet_currentFlatFiltered, dispatch, ft }) },
    handleSet_gsRankings: (gsValues, rankings_gs) => { dispatch({ type: rts.handleSet_gsRankings, dispatch, gsValues, rankings_gs }) },
    handleSet_gsRosters: (gsValues, rosters_gs) => { dispatch({ type: rts.handleSet_gsRosters, dispatch, gsValues, rosters_gs }) },
    handleSet_matchDataUpdates: (matchDataUpdates) => { dispatch({ type: rts.handleSet_matchDataUpdates, dispatch, matchDataUpdates }) },
    handleSet_matchPlayoffPendings: (matchPlayoffPendings) => { dispatch({ type: rts.handleSet_matchPlayoffPendings, dispatch, matchPlayoffPendings }) },
    handleSet_schoolResults: (schoolData) => { dispatch({ type: rts.handleSet_schoolResults, dispatch, schoolData }) },
    handleShow_matchEdit: (matchProp, match) => { dispatch({ type: rts.handleShow_matchEdit, dispatch, matchProp, match }) },
    handleUpdate_gsMatchesSport: (forPlayoffs, forRefresh, repairResults) => { dispatch({ type: rts.handleUpdate_gsMatchesSport, dispatch, forPlayoffs, forRefresh, repairResults }) },
    handleUpdate_gsRankings: (rankings_info) => { dispatch({ type: rts.handleUpdate_gsRankings, dispatch, rankings_info }) },
    ...responseHandlers(dispatch),
  }
}

export const sportsDataInitialState = (init_state) => {
  return { ...init_state }
};

export const sendMatchMessage = async (matchStatus, _holeResult) => {
}

export const sendFcmMessage = async (currentUserId) => {
}

